import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import { KeyFeatures } from "../../Components/KeyFeatures";
import QUANTUMGRAVIMETER from "../../Images/Boxes/GRAVIMETER_P1.png";

export default function QuantumGravimeter() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);

    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
  "Atoms are cooled to sub-microkelvin temperatures and launched in vacuum.",
"Three precisely timed Raman laser pulses split, redirect, and recombine atomic wave packets.",
"During free fall, gravity induces a phase shift proportional to g (gravitational acceleration).",
"Interference pattern readout yields absolute gravity measurement with stability and accuracy far superior to classical sensors (typically ~μGal to nGal levels).",
"This quantum approach provides absolute, drift-free measurements traceable to fundamental constants, with high repeatability even in dynamic environments.",


   "Ultra-high sensitivity - Detects gravity variations at parts-per-billion levels.",
"Absolute & calibration-free - No drift; ties directly to time & length standards.",
"Robust & portable designs - Field-deployable, vibration-resistant prototypes advancing toward compact systems.",
"Superior to classical gravimeters - Better long-term stability, reduced site visits, and environmental resilience.",
      "Room-temperature compatible components - Minimizing complexity compared to cryogenic alternatives.",
      "Transformative Applications",
"Geophysics & Resource Exploration - Subsurface mapping, groundwater detection, mineral/oil/gas reservoirs, volcanic monitoring.",
"Civil Engineering & Infrastructure - Void/cavity detection, sinkhole prediction, tunnel/bridge stability assessment.",
"Environmental & Climate Monitoring - Glacier melt, sea-level changes, flood/groundwater dynamics.",
"Navigation & Defence - Inertial navigation in GPS-denied environments, gravity-aided positioning.",
"Scientific Research - Fundamental gravity tests, dark matter/energy searches, planetary missions.",


   
  ];

  

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />
        <div className="w-full h-[25rem] ">
          <ProductsHeroSection
            title1="Quantum Gravimeter"
            title2="Measuring Gravity with Atomic Precision"
            content="Next-generation quantum gravimeters using cold atom interferometry to deliver ultra-precise, drift-free gravity measurements for geophysics, navigation, and scientific exploration. "
            scrollToArchitecture={scrollToArchitecture}
          />
        </div>

        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">
              Quantum Gravimeter: Ultra-Precise Gravity Sensing
            </span>
          </div>

          <div className="w-[90%] h-full   grid grid-cols-1 xl:grid-cols-2  place-items-start  p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                At QAIG, we are pioneering next-generation Quantum Gravimeters
                based on cold Rubidium atom interferometry delivering
                unprecedented precision in measuring gravitational acceleration
                for geophysics, inertial navigation in GPS denied environments,
                resource exploration, civil engineering, and beyond.
              </div>
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                Traditional gravimeters (spring-based or superconducting) suffer
                from drift, calibration needs, limited sensitivity, and
                environmental sensitivity. Our quantum gravimeter uses
                laser-cooled rubidium atoms as ideal, quantum test masses in
                free fall, interrogated via a matter-wave Mach-Zehnder
                interferometer created by cold rubidium atoms acting as matter
                waves and Raman laser pulses acting as the optical manipulator.
              </div>

              <div className="w-full px-3 flex items-start justify-start">
                <KeyFeatures
                  title="Core Working Principle"
                  features={keyFeatures.slice(0, 5)}
                />
              </div>
            </div>

            <div className="w-full  flex flex-col items-start justify-start  gap-1">
              <KeyFeatures
                title="Key Features"
                features={keyFeatures.slice(6, 16)}
              />

              {/* <KeyFeatures
                title="Game-Changing Applications"
                features={keyFeatures.slice(9, 13)}
              /> */}
            </div>
          </div>
          {/* <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start  ">
            <KeyFeatures
              title="Key Advantages"
              features={keyFeatures.slice(5, 9)}
            />

            <KeyFeatures
              title="Game-Changing Applications"
              features={keyFeatures.slice(22, 29)}
            />
          </div> */}
          <div className="w-[90%] h-full flex flex-col md:flex-row justify-center items-center gap-10 my-10">
            <div className="w-full flex flex-col items-center justify-center">
              <img
                className="w-[21.5rem]  lg:w-[600px]  object-contain rounded-lg md:rounded-2xl"
                src={QUANTUMGRAVIMETER}
              ></img>
              <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 mt-2">
                Figure 1: Schematic of a quantum repeater setup showing
                entanglement distribution via quantum memories, photon sources,
                and Bell-state measurements across segments.( Figueroa Research
                Group)
              </p>
            </div>
          </div>
          {/* <TitleContent
            title="Our Advancement"
            content="QAIG has demonstrated the first Made In India Quantum Memory using room temperature Rubidium vapours, and an Entangled Photon Source (EPS) two of the  essential repeater components in lab settings and is progressing toward next phase. We are currently focussing on integrating on quantum memories, efficient photon sources, and swapping modules  targeting deployment in national and commercial quantum networks. "
            scrollToArchitecture={scrollToArchitecture}
          /> */}
          <p className="w-full text-center font-bold  text-xs md:text-sm text-[#1B99D4] mt-2">
            Unlocking Earth's secrets — atom by atom.
          </p>
        </div>

        {/* <VideoComponent
          image={QSleeveImage}
          video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
        /> */}
        <div
          className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>

        <ProductFooter />
      </div>
    </div>
  );
}
